import type { ExampleIconAliases } from './icons';

const aliases: ExampleIconAliases = {
  dark: 'mdi-weather-night',
  light: 'mdi-weather-sunny',
  ltr: 'mdi-format-pilcrow-arrow-right',
  rtl: 'mdi-format-pilcrow-arrow-left',
  palette: 'mdi-palette',
  settings: 'mdi-cog',
  formatText: 'mdi-format-text',
  formOnly: 'mdi-dock-window',
  reload: 'mdi-reload',
  save: 'mdi-content-save',
};

export { aliases };
